import {SELECT_PAYMENT,SAVE_BILLINGINFO } from '../../Actions/EndUser/BillingAction';
export const reducer = (state = {selectedPayment:"Card",billingResponse:null}, action) => {
    switch (action.type) {
        case SELECT_PAYMENT:
            return {
                ...state,
                selectedPayment: action.selectedPayment
            };  
        case SAVE_BILLINGINFO:
            return {
                ...state,
                billingResponse: action.payload
            };
            default:
            return state;
    }
}
